// extracted by mini-css-extract-plugin
export default {"middleInitial":"individualForm_middleInitial__DzCh5"};